import { IdBuilding } from "../../../constants/IdBuilding";
import { createPathSelectBuildingInBuildMenu } from "../path/createPathSelectBuildingInBuildMenu";
export var pathSelectSimpleHouseInBuildMenu = function (action, state$, deps) {
    return createPathSelectBuildingInBuildMenu(function () {
        return IdBuilding.SimpleHouse;
    })(action, state$, deps);
};



//////////////////
// WEBPACK FOOTER
// ./src/features/show-me/missing-workers/pathSelectSimpleHouseInBuildMenu.ts
// module id = 2350
// module chunks = 3